import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import React, { Suspense } from "react";
import { Loader } from "@sequentech/ui-essentials";
import App from "./App";
import { ErrorPage } from "./routes/ErrorPage";
import { VotingPortalError, VotingPortalErrorType } from "./services/VotingPortalError";
import TenantEvent from "./routes/TenantEvent";
import { electionRoutes } from "./routes/electionRoutes";
import PreviewPublicationEvent from "./routes/PreviewPublicationEvent";
import PreviewFromFile from "./routes/PreviewFromFile";
import ElectionSelectionScreen from "./routes/ElectionSelectionScreen";
import LoginScreen from "./routes/LoginScreen";
import RegisterScreen from "./routes/RegisterScreen";
import SupportMaterialsScreen from "./routes/SupportMaterialsScreen";
export var ThrowCertAuthError = function () {
    throw new VotingPortalError(VotingPortalErrorType.CERT_AUTH_FAILED);
};
/** Children of `/tenant/:tenantId/event/:eventId`. */
export var tenantEventRoutes = [
    {
        path: "election-chooser",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(ElectionSelectionScreen, {}) })),
    },
    {
        path: "login",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(LoginScreen, {}) })),
    },
    {
        path: "enroll",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(RegisterScreen, {}) })),
    },
    electionRoutes,
    {
        path: "materials",
        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(SupportMaterialsScreen, {}) })),
    },
];
export var appRoutes = [
    {
        path: "/cert-auth-error",
        element: _jsx(ThrowCertAuthError, {}),
        errorElement: _jsx(ErrorPage, {}),
    },
    {
        path: "/",
        element: _jsx(App, {}),
        errorElement: _jsx(ErrorPage, {}),
        children: [
            {
                // Before the path-parameter route, so `file` is not read as
                // a tenant id.
                path: "/preview/file",
                element: _jsx(PreviewFromFile, {}),
            },
            {
                path: "/preview/:tenantId/:documentId/:areaId/:publicationId",
                element: _jsx(PreviewPublicationEvent, {}),
            },
            {
                path: "/tenant/:tenantId/event/:eventId",
                element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(TenantEvent, {}) })),
                children: tenantEventRoutes,
            },
        ],
    },
];
